// /**
//  * Create Grouping Product
//  */

// React
import React, { useEffect, useRef, useState } from 'react';

// UI
import theme from '../../theme';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import {
    Button,
    FormLabel,
    Grid,
    IconButton,
    Paper,
    Card,
    CardHeader,
    CardContent,
    TextField,
    Typography,
} from '@material-ui/core';
import jMoment from 'moment-jalaali';

import { useForm, Controller } from 'react-hook-form';

// Icon
import Icon from '@mdi/react';
import { mdiArrowRight, mdiImageOutline, mdiPaperclip } from '@mdi/js';

import { Link } from 'react-router-dom';
import List from './components/errorList';
import { UploadProductsRequestBuilder, UploadUpdateProductsRequestBuilder } from 'client-sdk/src/products/products';
import Client from 'client-sdk/src/client';
import handleNotfication from '../../utils/handleNotfication.tsx';
import { handleErrorList } from '../../utils/helpers';
import handleError from '../../utils/handleError';
import windowSize from '../../utils/hook/useWindowResize';
import GroupingAddProductMob from './mobileView/groupingAddProductMob';

jMoment.loadPersian({ dialect: 'persian-modern', usePersianDigits: true });

type Props = {
    history: any;
};

interface Errors {
    code: number;
    text: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            flexWrap: 'wrap',
            '& .MuiFormControl-marginNormal': {
                marginTop: 0,
            },
        },
        '.margin-date-0': {
            '&.MuiFormControl-marginNormal': {
                marginTop: 0,
            },
        },
        type: {
            flexGrow: 1,
            maxWidth: 500,
        },
        paper: {
            marginTop: '36px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            marginBottom: '36px',
            paddingTop: theme.spacing(3),
            paddingBottom: theme.spacing(3),
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            border: '1px solid #ddd',
            borderRadius: '4px',
            '@media (max-width: 768px)': {
                padding: theme.spacing(0),
                marginTop: theme.spacing(1),
                marginBottom: theme.spacing(3),
                backgroundColor: theme.palette.background.default,
            },
        },

        textInput: {
            // width: '25ch',
            '& input, .MuiSelect-root': {
                padding: '12px 10px 12px !important',
            },

            '& .MuiInput-underline::before': {
                borderBottom: '1px solid #d8d8d8 !important',
            },
        },
        headerBox: {
            marginLeft: '75px',
            display: 'flex',
            alignItems: 'center',
            marginBottom: '10px',
            marginTop: '10px',
        },
        item: {
            display: 'flex',
            alignSelf: 'center',
            alignItems: 'center',
            fontWeight: 500,
            width: '100%',
            '& > *': {
                // margin: theme.spacing(0, 0, 0, 1),
            },
        },
        icon: {
            color: '#8a8a8a',
            marginRight: theme.spacing(1),
        },
        typographyCards: {
            fontSize: '16px',
            color: 'white',
            backgroundColor: '#4BCF90',
            padding: '8px 24px 8px 50px',
            marginLeft: '-40px',
        },
        card: {
            marginBottom: '14px',
            overflow: 'visible',
            padding: '14px',
            paddingBottom: '0',
        },

        cardContent: {
            justifyContent: 'space-between',
            paddingLeft: '14px',
        },
        cardContentOrder: {
            paddingBottom: '10px',
        },
        labelInput: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'space-between',
            position: 'relative',
            padding: '15px',
            marginTop: '16px',
            borderRadius: '5px',
            border: 'solid 1px #949494',
            borderStyle: 'dashed',
            width: '100%',
            height: '150px',
        },
        uploadInput: {
            cursor: 'pointer',
            alignSelf: 'center',
            position: 'absolute',
            top: '0',
            right: '0',
            width: '100%',
            height: '100%',
            opacity: '0',
        },
    })
);

function GroupingUpdateProduct(props: Props) {
    const token = localStorage.getItem('token') || '';
    const classes = useStyles();
    const [file, setFile] = useState<any>(null);
    const [fileName, setFileName] = useState<any>('');
    const [errorList, setErrorList] = useState<Errors[]>([]);
    const [loading, setLoading] = useState(false as boolean);
    const { register } = useForm({});
    const [isMob, setIsMob] = useState(false);
    const { width } = windowSize();

    const handleChangeFileInput = (event: any) => {
        setFileName(event.target.files[0].name);
        if (event.target.files[0]) {
            setFile(event.target.files[0]);
        }
    };

    useEffect(() => {
        if (width && width <= 480) {
            setIsMob(true);
        } else {
            setIsMob(false);
        }
    }, [width]);

    const handleSubmitForm = () => {
        submitFile(file);
    };

    // @ts-ignore
    const submitFile = async file => {
        try {
            setLoading(true);
            let payload = new FormData();
            payload.append('file', file);
            const makeRequest = new UploadUpdateProductsRequestBuilder()
                .data(payload)
                .build();
            const client = new Client(token);
            await client.execute(makeRequest);
            handleNotfication('کالا‌ها با موفقیت ویرایش شدند', 'success');
            props.history.push('/your-products');
        } catch (err) {
            if (err.response?.status === 400) {
                handleNotfication(err.response?.data?.title, 'error');
            }
            if (err?.response.status === 406) {
                // @ts-ignore
                handleNotfication(
                    'فرمت فایل اپلود شده صحیح نمیباشد موارد را اصلاح کنید',
                    'error'
                );
                // @ts-ignore
                setErrorList(handleErrorList(err.response.data));
            }
            handleError(err.response);
        } finally {
            setFileName('');
            setFile(null);
            setLoading(false);
        }
    };

    const handleErrorList = (data: any) => {
        const errorList: Array<unknown> = [];
        for (const key in data) {
            if (Object.prototype.hasOwnProperty.call(data, key)) {
                const element = data[key];
                for (let index = 0; index < element.length; index++) {
                    const text = element[index];
                    errorList.push({ code: key, text })
                }
            }
        }

        return errorList
    }

    return (
        <>
            <Grid
                style={{
                    zIndex: 3,
                    backgroundColor: 'white',
                    position: 'fixed',
                    top: '0',
                    right: '71px',
                }}
                container
                direction="row"
                justify="space-between"
                alignItems="center"
            >
                <Paper
                    elevation={1}
                    style={{
                        width: '100%',
                        borderRadius: '0',
                    }}
                >
                    <div className={classes.headerBox}>
                        <Typography variant="h6" component="h2">
                            {`
ویرایش گروهی کالا        `}
                        </Typography>
                    </div>
                </Paper>
            </Grid>

            <Grid md={12}>
                <Card
                    className={classes.card}
                    style={{ marginTop: '0', paddingBottom: '24px' }}
                >
                    <CardHeader
                        avatar={
                            <Grid>
                                <Typography className={classes.typographyCards}>
                                    بارگذاری فایل
                                </Typography>
                            </Grid>
                        }
                    />

                    <CardContent className={classes.cardContentOrder}>
                        <Grid container lg={12} md={12} className={classes.cardContent}>
                            <Grid
                                container
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                style={{
                                    padding: '0',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                }}
                            >
                                <Grid container sm={5} md={5}>
                                    <Grid
                                        item
                                        xs={12}
                                        lg={12}
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'row-reverse',
                                            justifyContent: 'left',
                                            marginBottom: '-10px',
                                        }}
                                    >
                                        <Link
                                            to="/ProductUpdateSample.xlsx"
                                            style={{
                                                color: '#DFA01F',
                                                borderBottom: 'solid 1px #DFA01F',
                                                paddingBottom: '3px',
                                                textDecoration: 'none',
                                            }}
                                            target="_blank"
                                        >
                                            {' دریافت فایل نمونه'}
                                        </Link>
                                        <Link
                                            to="/ProductUpdateInstruction.xlsx"
                                            style={{
                                                paddingBottom: '3px',

                                                color: '#2F4858',
                                                marginLeft: '55px',
                                                textDecoration: 'none',
                                                borderBottom: 'solid 1px #2F4858',
                                            }}
                                            target="_blank"
                                        >
                                            {' دریافت فایل راهنما'}
                                        </Link>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        lg={12}
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <div style={{ display: 'flex', width: '100%' }}>
                                            <div className={classes.item}>
                                                <br />
                                                <label htmlFor="file" className={classes.labelInput}>
                                                    <Icon
                                                        color={'#666666'}
                                                        path={mdiPaperclip}
                                                        size={2}
                                                    />
                                                    <Typography>
                                                        {file ? file?.name : 'فایل خود را اینجا رها کنید'}
                                                    </Typography>
                                                    <Typography
                                                        style={{
                                                            color: '#0375E8',
                                                            borderBottom: 'solid 1px #0375E8',
                                                        }}
                                                    >
                                                        انتخاب فایل از کامپیوتر
                                                    </Typography>

                                                    <input
                                                        id="file"
                                                        type="file"
                                                        name="file"
                                                        onChange={handleChangeFileInput}
                                                        ref={register({ required: true })}
                                                        multiple
                                                        className={classes.uploadInput}
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Grid>
            {errorList?.length > 0 && <List data={errorList} />}
            <Grid
                container
                lg={12}
                md={12}
                xs={12}
                spacing={2}
                style={{
                    flexDirection: 'row-reverse',
                    position: 'fixed',
                    backgroundColor: '#D5DADD',
                    bottom: '0',
                    right: '75px',
                    padding: '15px',
                    zIndex: 2,
                }}
            >
                <Grid
                    container
                    style={{
                        marginLeft: '35px',
                        marginTop: '-4px',
                    }}
                >
                    <Button
                        variant="outlined"
                        color="primary"
                        size="medium"
                        onClick={() => window.history.back()}
                        style={{
                            marginRight: 'auto',
                            padding: '2px 30px',
                        }}
                    >
                        {'انصراف'}
                    </Button>
                    <Button
                        style={{
                            marginRight: '14px',
                            marginLeft: '90px',
                        }}
                        type="submit"
                        disabled={loading}
                        size="medium"
                        data-cy="search"
                        autoFocus
                        variant="contained"
                        color="primary"
                        onClick={handleSubmitForm}
                    >
                        ویرایش کالا
                    </Button>
                </Grid>
            </Grid>
        </>
    );
}

export default GroupingUpdateProduct;
